import CloseIcon from "@mui/icons-material/Close";
import { IconButton, StepLabel } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import StepConnector from "assets/img/svg/stepConnector";
import classNames from "classnames";
import type { CSSProperties, ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

import StyledStep from "../StyledStepper";
import styles from "./style.module.scss";

interface MultiStepProps {
    activeStep: number;
    standaloneMoveBetweenSteps?: boolean;
    onStepChange?: (direction: "prev" | "next" | null, newStep: number) => void;
    onClose: () => void;
    children?: ReactNode | ReactNode[];
    prevButton?: ReactNode;
    nextButton?: ReactNode;
    steps: { title: string; component: ReactNode; hidden?: boolean }[];
    id?: string;
    title: string;
    subtitle?: ReactNode;
    fullscreen?: boolean;
    extraFullscreen?: boolean;
    /**
     * Show mui animated stepper, doesn't work with standaloneMoveBetweenSteps prop
     */
    animatedStepper?: boolean;
    // className?: string;
    style?: CSSProperties;
}

const MultiStep = ({
    animatedStepper = false,
    extraFullscreen,
    fullscreen,
    subtitle,
    title,
    id,
    steps,
    nextButton,
    prevButton,
    children,
    onClose,
    onStepChange,
    standaloneMoveBetweenSteps,
    activeStep,
    style,
}: MultiStepProps) => {
    const multistepContainerRef = useRef<HTMLDivElement | null>(null);

    const handleStepChange = (idx: number) => {
        if (standaloneMoveBetweenSteps === true && idx < activeStep) {
            onStepChange && onStepChange(null, idx);
        }
    };

    const filteredSteps = steps?.filter((step) => !step.hidden);

    return (
        <div
            className={classNames({
                [styles.multistepWrapper]: true,
                [styles.multistepWrapperFullscreen]: fullscreen,
                [styles.multistepWrapperExtraFullscreen]: extraFullscreen,
            })}
            ref={multistepContainerRef}
            style={style}
        >
            {/* <div id={props.id} className={styles.multistepContainer}> */}
            <div
                id={id}
                className={classNames({
                    [styles.multistepContainer]: true,
                    [styles.multistepContainerExtraFullwidth]: extraFullscreen,
                })}
            >
                <div className={styles.multistepList}>
                    <div className={styles["multistep-head"]}>
                        <div className={styles["multistep-title"]}>{title}</div>
                        <div className={styles["multistep-subtitle"]}>{subtitle}</div>
                    </div>
                    {animatedStepper && filteredSteps.length > 1 && (
                        <Stepper
                            nonLinear
                            activeStep={activeStep}
                            connector={<StepConnector />}
                            sx={{ gap: "10px", justifyContent: "center" }}
                        >
                            {filteredSteps?.map((step, index) => {
                                return (
                                    <StyledStep key={step.title} className={index < activeStep ? "resolved" : ""}>
                                        <StepLabel>{step.title}</StepLabel>
                                    </StyledStep>
                                );
                            })}
                        </Stepper>
                    )}

                    {filteredSteps.length > 1 &&
                        !animatedStepper &&
                        filteredSteps?.map((step, idx) => {
                            return (
                                <div className={styles.multistepItemContainer} key={`list${idx}`}>
                                    <div
                                        className={classNames({
                                            [styles.multistepItem]: 1,
                                            [styles.multistepItem_clickable]:
                                                standaloneMoveBetweenSteps && idx < activeStep,
                                            [styles.multistepItem_active]: activeStep == idx,
                                            [styles.multistepItem_done]: activeStep > idx,
                                        })}
                                        onClick={(e) => handleStepChange(idx)}
                                    >
                                        <span className={styles.multistepIndex}>{(idx + 1).toString()}</span>
                                        <span className={styles.multistepLabel}>{step.title}</span>
                                    </div>
                                </div>
                            );
                        })}
                    <div className={styles["multistep-close"]}>
                        {" "}
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>{" "}
                    </div>
                </div>

                <div className={styles.multistepComponentList}>{filteredSteps[activeStep].component}</div>
            </div>
        </div>
    );
};

export default MultiStep;
